import { Component, OnInit, Input } from "@angular/core";
import { BlogService } from "src/services/blog.service";
import { ViewBlogComponent } from "src/app/content-area/view-blog/view-blog.component";
@Component({
  selector: "app-blog-item",
  templateUrl: "./blog-item.component.html",
  styleUrls: ["./blog-item.component.css"],
})
export class BlogItemComponent implements OnInit {
  @Input() blogDetail;
  blogId = "";

  constructor(private blogdetailservice: BlogService) {}

  ngOnInit(): void {}

  viewBloglink(id: string) {
    const link = "/blog/" + id;
    return link;
  }

  getImageUrl(imageUrl) {
    if (!imageUrl || imageUrl === "empty") {
      return "../../../assets/images/Blog-demo.jpg";
    } else {
      return imageUrl;
    }
  }

  getImageUrl_profile(imageUrl) {
    if (!imageUrl || imageUrl === "empty") {
      return "../../../assets/images/empty-profile.png";
    } else {
      return imageUrl;
    }
  }
}
